











































import { Tree } from 'element-ui';
import { editFactory } from '@/main/pages';
import DmsTree from '@/main/components/dms/Tree.vue';
import _ from 'lodash';

import { store } from './store/edit';
import { NAME, ModuleName, MENU_CODE, TAB_NAMES, TABS } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		DmsTree,
	},
	data() {
		return {
			treeProps: {
				children: 'Children',
				label: 'Text',
			},
			tabNames: TAB_NAMES,
		};
	},
	computed: {
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.MenuOperations)) tabItems.push(TAB_NAMES.MENUOPERATIONS);
			if (this.hasTabAccess(MENU_CODE, TABS.MenuTabs)) tabItems.push(TAB_NAMES.MENUTABS);

			return _.pick(TABS, tabItems);
		},
	},
	methods: {
		async loadData() {
			await this.entity();
			await this.getRoleBaseTreeView();
			this.getUserMenuTree();
		},
		localizeContent(items: any) {
			if (Array.isArray(items.Children)) {
				items.Text = this.LocalizeMenu(items.Text);
				items.Children.forEach(this.localizeContent);
			} else {
				items.Text = this.multiKey(items.Text);
			}
		},
		multiKey(key: string) {
			const labelKey = key.split(', ');
			return labelKey.length > 1 ? this.LocalizeMultiKeyToCommaString(`${labelKey[0]}/${labelKey[1]}`) : this.LocalizePopisostatni(labelKey[0]);
		},
		getUserMenuTree() {
			this.menuOperations = this.MenuOperations;
			this.menuTabs = this.MenuTabs;

			this.menuOperations.forEach(this.localizeContent);
			this.menuTabs.forEach(this.localizeContent);

			this.SelectedOperations.forEach((element: any) => this.selectedOperations.push(element.Id));
			this.SelectedTabs.forEach((element: any) => this.selectedTabs.push(element.Id));
		},
		ConvertSubToMainModule() {
			this.menuTree
				.find((elGroupTree: any) => elGroupTree.Text === ModuleName.Customers)!.children = this.menuTree
				.find((elGroupTree: any) => elGroupTree.Text === ModuleName.Customers)!.children[0].children;

			this.menuTree
				.find((elGroupTree: any) => elGroupTree.Text === ModuleName.Vehicles)!.children = this.menuTree
				.find((elGroupTree: any) => elGroupTree.Text === ModuleName.Vehicles)!.children[0].children;
		},
		async saveClick() {
			this.MenuIds = (this.$refs.operationsTree as any).getChecked().map((el: any) => el.Id).filter((el: any) => el);
			this.TabIds = (this.$refs.tabsTree as any).getChecked().map((el: any) => el.Id).filter((el: any) => el);
			await this.save();
		},
		reset() {
			(this.$refs.menuTree as any).reset();
			this.getUserMenuTree();
		},
	},
});
